module.exports=[
    {
        "id": 1,
        "text_fr": " ",
        "text_en": " ",
        "btn_text_fr": " ",
        "btn_text_en": " ",
        "img_fr": "null.gif",
        "img_en": "null.gif",
        "lien_fr": "",
        "lien_en": ""
    }
]
